function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.19403 0.466797H1.6188C1.0236 0.466797 0.536621 0.953776 0.536621 1.54897V9.1242C0.536621 9.7194 1.0236 10.2064 1.6188 10.2064H9.19403C9.78923 10.2064 10.2762 9.7194 10.2762 9.1242V1.54897C10.2762 0.953776 9.78923 0.466797 9.19403 0.466797ZM9.19403 9.1242H1.6188V1.54897H9.19403V9.1242ZM2.70097 4.25441H3.78315V8.04203H2.70097V4.25441ZM4.86532 2.63115H5.9475V8.04203H4.86532V2.63115ZM7.02968 5.87768H8.11185V8.04203H7.02968V5.87768Z",
  fill: "#3456FF"
});

function SvgIconBarGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarGraph);
export default __webpack_public_path__ + "static/media/icon-bar-graph.d6dc621a.svg";
export { ForwardRef as ReactComponent };